import React, { useMemo, useState } from "react";
import DashboardWidgetService from "../../../../services/dashboard-widgets";
import { Button, CircularProgress, Grid } from "@material-ui/core";
import { isEmpty } from "lodash";
import "./style.css";
import SubscriptionInfoTable from "./subscription-info-tabel";
import DatePicker from "../../../base/date-picker";
import moment from "moment";
import StatsPanel from "../chart-container";

export const DATA_FETCH_STATUSES = Object.freeze({
  INITIAL: "initial",
  FETCHING: "fetching",
  FETCHED: "fetched",
});

const SubscriptionOverview = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tableData, setTableData] = useState({ tableBody: [], tableSum: {} });
  const [dataFetchingStatus, setDataFetchingStatus] = useState(
    DATA_FETCH_STATUSES.INITIAL
  );

  const onClickShowResults = async () => {
    setDataFetchingStatus(DATA_FETCH_STATUSES.FETCHING);
    DashboardWidgetService.getSubscriptionDashboardData({
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
    })
      .then((res) => {
        const subscriptionStats = res.body;
        let output = { tableBody: [], tableSum: {} };
        if (!isEmpty(subscriptionStats) && Array.isArray(subscriptionStats)) {
          let totNew = 0;
          let totRenew = 0;
          let totCancel = 0;

          subscriptionStats.forEach((element) => {
            totNew += element.totalNew;
            totRenew += element.totalRenew;
            totCancel += element.totalCancel;
          });

          output["tableSum"] = { totNew, totRenew, totCancel };
          output["tableBody"] = subscriptionStats;
        }
        setTableData(output);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setDataFetchingStatus(DATA_FETCH_STATUSES.FETCHED);
      });
  };

  return (
    <StatsPanel title="Subscription Overview">
      <Grid item container className="gap-x-16">
        <DatePicker
          label="From"
          selectedDate={startDate}
          onChangeDate={(date) => setStartDate(date)}
        />
        <DatePicker
          label="To"
          selectedDate={endDate}
          onChangeDate={(date) => setEndDate(date)}
        />
        <Button
          className="show-results-btn"
          onClick={() => onClickShowResults()}
          disabled={
            !startDate ||
            !endDate ||
            moment(startDate).isAfter(endDate) ||
            dataFetchingStatus === DATA_FETCH_STATUSES.FETCHING
          }
        >
          {dataFetchingStatus === DATA_FETCH_STATUSES.FETCHING ? (
            <CircularProgress size={15} />
          ) : (
            "Show Results"
          )}
        </Button>
      </Grid>
      {dataFetchingStatus !== DATA_FETCH_STATUSES.INITIAL && (
        <SubscriptionInfoTable
          tableData={tableData}
          dataFetchingStatus={dataFetchingStatus}
        />
      )}
    </StatsPanel>
  );
};

export default SubscriptionOverview;
